module.exports = __webpack_public_path__ + "static/2-004-75e208b9a96f7827281ebc2d031fcf32.jpg";